import { motion } from "framer-motion";
import { Outlet, useLocation } from "react-router-dom";

const ReportAppLayout = () => {
  const { pathname } = useLocation();

  return (
    <motion.main
      style={{
        width: "100%",
        height: "100vh",
        minHeight: "100vh",
        overflow: "auto",
        background: "#ffffff",
      }}
      id="main"
      key={pathname}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.45,
        ease: [0.6, -0.05, 0.01, 0.99],
      }}
    >
      <Outlet></Outlet>
    </motion.main>
  );
};

export default ReportAppLayout;
